/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo, useState } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useIgnorePriceValidation = ({ list, value, onChange }: any) => {
  function mapCustomers(customers: any) {
    return customers.reduce((acc: any, customer: any) => {
      acc[customer.customer_id] = customer.customer_name;
      return acc;
    }, {});
  }

  const customerMap = mapCustomers(list);
  const [showMore, setShowMore] = useState(false);
  const [sortKey, setSortKey] = useState<any>("customer_name");
  const [sortOrder, setSortOrder] = useState<any>("desc");
  const displayList = useMemo(() => {
    try {
      return Object.keys(value);
    } catch (_error) {
      return [];
    }
  }, [value]);

  const handleSorting = (prop: string) => {
    if (sortKey === prop) {
      setSortOrder((prev: string) => (prev === "desc" ? "as" : "desc"));
    } else {
      setSortOrder("asc");
    }
    setSortKey(prop);
  };

  // const handleAddUser = (prop: any) => {
  //   const existKeys = Array.isArray(value) ? Object.keys(value) : [];
  //   console.log({ prop, value });
  //   const newList = prop.filter((propKey: any) => !existKeys.includes(propKey)).reduce((acc:string,curr:string[])=>(...acc,[curr]:[]),{});
  //   const temp = { ...newList, ...value };
  //   console.log({ temp });
  //   onChange(temp);
  // };

  const handleAddUser = (prop: any) => {
    const existKeys =
      value && typeof value === "object" && !Array.isArray(value)
        ? Object.keys(value)
        : [];

    console.log({ prop, value });

    const newList = prop
      .filter((propKey: string) => !existKeys.includes(propKey))
      .reduce((acc: Record<string, any[]>, curr: string) => {
        acc[curr] = [];
        return acc;
      }, {});

    const temp = { ...newList, ...value };

    console.log({ temp });
    onChange(temp);
  };

  const onChangeHandler = (key: any, propValue: any) => {
    if (!value[key]) return;
    const temp = { ...value, [key]: propValue };
    onChange(temp);
  };

  const [selectedForDeletion, setSelectedForDeletion] = useState<string[]>([]);

  const deleteSelectionToggle = () => {
    if (selectedForDeletion?.length === sortedKeys?.length) {
      setSelectedForDeletion([]);
    } else {
      setSelectedForDeletion(sortedKeys);
    }
  };

  const handleToggleForDeletion = (key: string) => {
    setSelectedForDeletion((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const removeSelectedUsers = () => {
    if (selectedForDeletion.length === 0) return;
    const temp = { ...value };
    selectedForDeletion.forEach((key) => {
      delete temp[key];
    });
    onChange(temp);
    setSelectedForDeletion([]);
  };

  const sortedKeys = useMemo(() => {
    if (!value || typeof value !== "object") return [];

    let keys = Object.keys(value);

    if (sortKey === "customer_name" && list) {
      const nameMap: any = {};
      list.forEach((item: any) => {
        nameMap[item.customer_id] = item.customer_name?.toLowerCase?.() || "";
      });
      keys = keys.sort((a, b) => {
        const nameA = nameMap[a] || "";
        const nameB = nameMap[b] || "";
        if (sortOrder === "desc") return nameB.localeCompare(nameA);
        else return nameA.localeCompare(nameB);
      });
    } else {
      keys = keys.sort((a, b) => {
        if (sortOrder === "desc") return b.localeCompare(a);
        else return a.localeCompare(b);
      });
    }

    return keys;
  }, [value, sortKey, sortOrder, list]);

  return {
    customerMap,
    handleAddUser,
    onChangeHandler,
    handleToggleForDeletion,
    removeSelectedUsers,
    selectedForDeletion,
    displayList,
    showMore,
    setShowMore,
    sortKey,
    setSortKey,
    sortOrder,
    sortedKeys,
    setSortOrder,
    handleSorting,
    deleteSelectionToggle,
  };
};
